import React, { SVGProps } from "react";

export default function SupGas(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3.5C6.89543 3.5 6 4.39543 6 5.5V7.5C6 8.60457 6.89543 9.5 8 9.5H10C11.1046 9.5 12 8.60457 12 7.5V5.5C12 4.39543 11.1046 3.5 10 3.5H8ZM10 4.5H8C7.44772 4.5 7 4.94772 7 5.5V7.5C7 8.05228 7.44772 8.5 8 8.5H10C10.5523 8.5 11 8.05228 11 7.5V5.5C11 4.94772 10.5523 4.5 10 4.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 15.2676V13H13.9874C14.0604 13 14.1241 13.0495 14.1422 13.1203C14.3948 14.1114 15.7132 14.3141 16.2519 13.4447L16.3181 13.3379C16.437 13.146 16.5 12.9247 16.5 12.6989L16.5 5.32845C16.5 4.6654 16.2366 4.02951 15.7678 3.56067L14.3536 2.14645L13.6464 2.85355L15.0607 4.26778C15.0779 4.285 15.0947 4.30261 15.111 4.32057L14 5.26951L14 7.00003C14 7.93193 14.6374 8.71497 15.5 8.93699L15.5 12.6989C15.5 12.7386 15.4889 12.7775 15.468 12.8112L15.4018 12.918C15.3276 13.0378 15.146 13.0099 15.1112 12.8733C14.9803 12.3596 14.5176 12 13.9874 12H13.5V4C13.5 2.89543 12.6046 2 11.5 2H6.5C5.39543 2 4.5 2.89543 4.5 4V15.2676C3.9022 15.6134 3.5 16.2597 3.5 17V18H14.5V17C14.5 16.2597 14.0978 15.6134 13.5 15.2676ZM11.5 3H6.5C5.94772 3 5.5 3.44772 5.5 4V15H12.5V4C12.5 3.44772 12.0523 3 11.5 3ZM15.5 7.86622L15.5 5.32845C15.5 5.32015 15.5 5.31186 15.4998 5.30357L15 5.73048L15 7.00003C15 7.37016 15.2011 7.69331 15.5 7.86622ZM5.5 16C4.94772 16 4.5 16.4477 4.5 17H13.5C13.5 16.4477 13.0523 16 12.5 16H5.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
